import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const Profile = lazy(() => import('./index'));
const GetHelp = lazy(() => import('./GetHelp'));

export const ProfileRoutes: RouteObject = {
  path: '/dashboard/profile',
  handle: {
    label: 'Profile',
  },
  element: (
    <Suspense>
      <Profile />
    </Suspense>
  ),
};

export const GetHelpRoutes: RouteObject = {
  path: '/dashboard/get-help',
  handle: {
    label: 'Get Help',
  },
  element: (
    <Suspense>
      <GetHelp />
    </Suspense>
  ),
};
